<div class="labeled-row">
  <div class="label">{{label}}</div>
  <div class="value ellipsis">
    <ng-content></ng-content>
  </div>
</div>

